import { StateCreator } from "zustand";

export interface OrderSlice {
  orderId?: string;
  setOrderId?: (id: string) => void;
}

export const createOrderSlice: StateCreator<OrderSlice> = (set) => ({
  orderId: undefined,
  setOrderId: (orderId: string) => set({ orderId: orderId }),
});
